import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';

export const NudgeCategoryEdit = () => (
  <MoonstarEdit redirect="list" hideDelete>
    <MoonstarEditForm>
      <SimpleStack>
        <TextInput source="name" validate={required()} />
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);
